module.exports = __webpack_public_path__ + "64bb6a45da498cbaf2196d97b02b702d.pdf";